export default "__VITE_ASSET__DLj1LX$x__"